module.exports = __webpack_public_path__ + "static/newsletter-016c68f521e655e00367120f70953be0.jpg";